// extracted by mini-css-extract-plugin
export default {"referModalBox":"videoModal_referModalBox__qhTuL","referModalTop":"videoModal_referModalTop__T-pp-","close":"videoModal_close__-Ofzo"};